export const iconSize = 40;
